import React, { useState } from 'react';
import { Navbar } from '../Navbar';
import { TeacherSidebar } from '../TeacherSidebar';
import { Footer } from '../Footer';
import { MenuIcon, XIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
interface TeacherLayoutProps {
  children: React.ReactNode;
}
export const TeacherLayout: React.FC<TeacherLayoutProps> = ({
  children
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gray-50'}`} data-id="element-1541">
      <Navbar setIsDeleteAccountModalOpen={() => {}} data-id="element-1542" />
      {/* Mobile sidebar toggle button */}
      <div className="lg:hidden fixed bottom-6 right-6 z-50" data-id="element-1543">
        <button onClick={toggleSidebar} className="bg-deep-pink hover:bg-burgundy text-white p-3 rounded-full shadow-lg transition-colors" aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'} data-id="element-1544">
          {sidebarOpen ? <XIcon className="h-6 w-6" data-id="element-1545" /> : <MenuIcon className="h-6 w-6" data-id="element-1546" />}
        </button>
      </div>
      <div className="flex" data-id="element-1547">
        {/* Sidebar for larger screens - added background and shadow classes */}
        <div className={`hidden lg:block lg:w-64 fixed h-full overflow-y-auto pt-20 ${isDark ? 'bg-navy-800 shadow-lg' : 'bg-white shadow-md'} z-20`} data-id="element-1548">
          <TeacherSidebar darkMode={isDark} data-id="element-1549" />
        </div>
        {/* Mobile sidebar - overlay */}
        {sidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden" onClick={() => setSidebarOpen(false)} data-id="element-1550"></div>}
        {/* Mobile sidebar - content - updated background and shadow classes */}
        <div className={`fixed inset-y-0 left-0 z-20 w-64 ${isDark ? 'bg-navy-800 shadow-lg' : 'bg-white shadow-md'} transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out lg:hidden`} data-id="element-1551">
          <div className="pt-20" data-id="element-1552">
            <TeacherSidebar darkMode={isDark} closeSidebar={() => setSidebarOpen(false)} data-id="element-1553" />
          </div>
        </div>
        {/* Main content - fixed pl-64 to exactly match sidebar width with no gap */}
        <div className="w-full lg:pl-64 pt-20" data-id="element-1554">
          <main className={`p-6 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-1555">
            {children}
          </main>
        </div>
      </div>
      <Footer data-id="element-1556" />
    </div>;
};